/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import axios from 'axios';

import { SecurityHelper } from 'sarsaparilla';
import * as InternalSecurityUtils from 'ui-internal-account/src/utilities/internalSecurityUtil';
import type {
    GetWalletResponse,
    GetNewWalletTokenResponse,
} from './digital-wallet-types';

export async function getNewWalletToken() {
    return axios
        .get<GetNewWalletTokenResponse>('/api/cart/wallet/new', {
            headers: { Authorization: SecurityHelper.getAuthHeader() },
        })
        .then((response) => {
            return response.data;
        });
}

export async function getWallet(signal: AbortSignal) {
    return axios
        .get<GetWalletResponse>('/api/cart/wallet/v2', {
            signal,
            headers: { Authorization: SecurityHelper.getAuthHeader() },
        })
        .then((response) => {
            const data = response.data;
            return data;
        });
}

export async function deleteSavedCard(entryId: string) {
    return axios.delete(`/api/cart/wallet/${entryId}`, {
        data: {},
        headers: { Authorization: SecurityHelper.getAuthHeader() },
    });
}

export async function putCardUpdate({
    entryId,
    nickname,
    isDefault,
}: {
    entryId: string;
    nickname: string;
    isDefault: boolean;
}) {
    return axios.put(
        `/api/cart/wallet/${entryId}`,
        {
            name: nickname,
            is_default: isDefault,
        },
        {
            headers: { Authorization: SecurityHelper.getAuthHeader() },
        }
    );
}

export async function addCard({
    walletToken,
    nickname,
    isDefault,
    cardData,
}: {
    walletToken: string;
    nickname: string;
    isDefault: boolean;
    cardData: {
        number: string;
        expiration_month: number;
        expiration_year: number;
        validation_code: string;
    };
}) {
    return axios.post(
        `${process.env.PRS_API}/wallet`,
        {
            wallet_token: walletToken,
            name: nickname,
            is_default: isDefault,
            card_data: {
                number: cardData['number'],
                expiration_month: cardData['expiration_month'],
                expiration_year: cardData['expiration_year'],
                validation_code: cardData['validation_code'],
            },
        },
        {
            headers: { Authorization: SecurityHelper.getAuthHeader() },
        }
    );
}

export async function postUnlockChallengeAnswer({
    lastFour,
    expiration,
    internal_account_id,
    account_id,
}: {
    lastFour: string;
    expiration?: string | null;
    internal_account_id?: string | null;
    account_id?: string | null;
}) {
    const body: Record<string, string> = {
        last_four: lastFour,
    };

    if (expiration) {
        body.expiration = expiration;
    }

    let auth = SecurityHelper.getAuthHeader();

    if (internal_account_id && account_id) {
        body.internal_id = internal_account_id;
        body.account_id = account_id;
        auth = InternalSecurityUtils.getAuthHeader();
    }

    return axios.post('/api/cart/wallet/challenge', body, {
        headers: { Authorization: auth },
    });
}
